module.exports = __webpack_public_path__ + "media/images/first-championship-desktop-70764dcbe24355763ed100bac383fc1c.jpg";